<div class="row">
    <div class="col-12" *ngIf="title">
        <h4>{{title}}</h4>
    </div>
    <div class="col-12">
        <ng-container *ngTemplateOutlet="cardContentTpl || defaultContentTpl; context:filterContentTplContext"></ng-container>
        <ng-template #defaultContentTpl>
            {{value}}
        </ng-template>
    </div>
</div>


